export default "__VITE_ASSET__CTb27E4a__"